import { Component, OnInit } from '@angular/core';
import { KeepAliveFilesService } from 'src/app/core/services/keepAliveFiles.service';
import { DatePipe } from '@angular/common';
import {
  CommandP2PType,
  FileInfo,
  CommandP2P,
  RemoveCommandP2P,
} from 'src/app/core/models/keepAliveFiles.model';
import { HttpErrorResponse } from '@angular/common/http';
import { ToastService } from 'src/app/shared/widget/notification/toast-service';

import { AuthService } from 'src/app/core/services/auth.service';
import { User } from 'src/app/core/models/persons.model';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-keep-alive-files',
  templateUrl: './keep-alive-files.component.html',
  styleUrls: ['./keep-alive-files.component.scss'],
  providers: [DatePipe],
})
export class KeepAliveFilesComponent implements OnInit {
  constructor(
    private keepAliveFilesService: KeepAliveFilesService,
    private authService: AuthService,
    public datePipe: DatePipe,
    public modalService: NgbModal,
    public toastService: ToastService
  ) {
    this.user = this.authService.currentUserValue;
  }
  user: User;
  lastFile: any[] = [];
  lastFileInfo: FileInfo = new FileInfo();
  newCommand: CommandP2P = new CommandP2P();
  newCommandOutputControlPortAux = 1;
  commandSend: CommandP2P[] = [];
  commandP2PType: CommandP2PType[] = [];
  circularProgressiveWait = false;
  filesIdsCount: { fileId: any[]; count: number[] } = { fileId: [], count: [] };
  filtroSerial : string = "";

  devicesCanDownload: DeviceCanDownload[] = [];
  newSerialCanDownload: string = '';

  ngOnInit(): void {
    this.getLastFile();
    this.circularProgressiveWait = true;
    this.keepAliveFilesService.getCommandP2PType().subscribe(
      (response: any) => {
        this.commandP2PType = response;
        this.circularProgressiveWait = false;
      },
      (error: HttpErrorResponse) => {
        this.toastService.show(
          'Erro ao carregar tipo dos comandos p2p- ' + error.message,
          {
            classname: 'bg-danger text-center text-white',
            delay: 10000,
          }
        );
        this.circularProgressiveWait = false;
      }
    );
  }

  returnPlaceholderSetParamCommandP2P(id: number) {
    let index = this.commandP2PType.findIndex((item: CommandP2PType) => {
      return item.id == id;
    });
    if (index > -1) {
      return this.commandP2PType[index].exemplo;
    } else {
      return '';
    }
  }

  verificarSeTemParametro(id: number) {
    let index = this.commandP2PType.findIndex((item: CommandP2PType) => {
      return item.id == id;
    });
    if (index > -1) {
      return this.commandP2PType[index].temParametro;
    } else {
      return false;
    }
  }

  arquivosPaginalAtual = 1;
  itensPorPagina = 10;

  get totalPaginas(): number {
    return Math.ceil(this.lastFile.length / this.itensPorPagina);
  }
  get dadosPaginados() {
    const inicio = (this.arquivosPaginalAtual - 1) * this.itensPorPagina;
    return this.lastFile.slice(inicio, inicio + this.itensPorPagina);
  }
  proximaPagina() {
    if (this.arquivosPaginalAtual < this.totalPaginas) {
      this.arquivosPaginalAtual++;
    }
  }
  paginaAnterior() {
    if (this.arquivosPaginalAtual > 1) {
      this.arquivosPaginalAtual--;
    }
  }

  dispositivosPaginalAtual = 1;
  itensPorPaginaDispositivos = 100;

  get totalPaginasDispositivos(): number {
    return Math.ceil(this.devicesCanDownload.length / this.itensPorPaginaDispositivos);
  }
  get dadosPaginadosDispositivos() {
    const inicio = (this.dispositivosPaginalAtual - 1) * this.itensPorPaginaDispositivos;
    return this.devicesCanDownload.slice(inicio, inicio + this.itensPorPaginaDispositivos);
  }
  proximaPaginaDispositivos() {
    if (this.dispositivosPaginalAtual < this.totalPaginasDispositivos) {
      this.dispositivosPaginalAtual++;
    }
  }
  paginaAnteriorDispositivos() {
    if (this.dispositivosPaginalAtual > 1) {
      this.dispositivosPaginalAtual--;
    }
  }

  onFiltroChange() {
    this.dispositivosPaginalAtual = 1;
  }

  openModal(centerDataModal: any) {
    this.modalService.open(centerDataModal, {
      centered: true,
      windowClass: 'modal-holder',
    });
  }
  addCommand() {
    this.circularProgressiveWait = true;

    this.commandSend = [];
    let loraidAux = this.newCommand.loraid.split(';');
    let serialAux = this.newCommand.serial.split(';');
    if (loraidAux.length != serialAux.length) {
      this.toastService.show(
        'Quantidade de seriais não bate com a quantidade de LoraId, conferir!!',
        {
          classname: 'bg-danger text-center text-white',
          delay: 10000,
        }
      );
      this.circularProgressiveWait = false;
    } else {
      for (let index = 0; index < serialAux.length; index++) {
        const element = serialAux[index];
        let commandAux: CommandP2P = new CommandP2P();
        commandAux.serial = serialAux[index];
        commandAux.loraid = loraidAux[index];
        commandAux.p2pTipoComando = this.newCommand.p2pTipoComando;
        let CommandtemParametro =
          this.commandP2PType[
            this.commandP2PType.findIndex((item: CommandP2PType) => {
              return item.id == this.newCommand.p2pTipoComando;
            })
          ].temParametro;
        if (CommandtemParametro == undefined ? false : CommandtemParametro) {
          if (this.newCommand.p2pTipoComando == 2) {
            commandAux.p2pParam = this.newCommand.p2pParam == '0' ? '02' : '01';
            if (this.newCommandOutputControlPortAux < 10) {
              commandAux.p2pParam =
                '0' + this.newCommandOutputControlPortAux + commandAux.p2pParam;
            } else {
              commandAux.p2pParam =
                this.newCommandOutputControlPortAux + commandAux.p2pParam;
            }
          } else {
            commandAux.p2pParam = this.newCommand.p2pParam;
          }
        } else {
          commandAux.p2pParam = '0';
        }
        commandAux.forcarEnvio = this.newCommand.forcarEnvio;
        commandAux.p2pTimeout = String(
          new Date(this.newCommand.p2pTimeout).getTime()
        );
        commandAux.userid = this.user.userId;

        this.commandSend.push(commandAux);
      }

      this.keepAliveFilesService.addCommands(this.commandSend).subscribe(
        (response: any) => {
          let result: any[] = [];
          response.forEach((item: any) => {
            if (item.adicionado == false) {
              result.push(item.serial);
            }
          });

          if (result.length > 0) {
            this.toastService.show(
              'Erro ao adicionar os seriais - ' + result.join(';'),
              {
                classname: 'bg-warning text-center text-white',
                delay: 10000,
              }
            );
          } else {
            this.toastService.show('Seriais adicionados com sucesso ', {
              classname: 'bg-success text-center text-white',
              delay: 2500,
            });
          }

          this.circularProgressiveWait = false;
          this.getLastFile();
        },
        (error: HttpErrorResponse) => {
          this.toastService.show(
            'Erro ao adicionar seriais - ' + error.message,
            {
              classname: 'bg-danger text-center text-white',
              delay: 10000,
            }
          );
          this.circularProgressiveWait = false;
          this.getLastFile();
        }
      );
    }
  }

  removeCommand(serial: string, loraid: string) {
    this.circularProgressiveWait = true;
    let removeCommand: RemoveCommandP2P = new RemoveCommandP2P();

    removeCommand.serial = serial;
    removeCommand.loraid = loraid;
    removeCommand.userid = this.user.userId;

    this.keepAliveFilesService.removeDeviceCommands(removeCommand).subscribe(
      (response: any) => {
        this.toastService.show('Seriais removido com sucesso ', {
          classname: 'bg-success text-center text-white',
          delay: 2500,
        });
        this.circularProgressiveWait = false;
        this.getLastFile();
      },
      (error: HttpErrorResponse) => {
        this.toastService.show('Erro ao remover serial - ' + error.message, {
          classname: 'bg-danger text-center text-white',
          delay: 10000,
        });
        this.circularProgressiveWait = false;
        this.getLastFile();
      }
    );
  }

  private parseLoraActionsItems(raw: unknown): any {
    if (raw == null) {
      return null;
    }
    if (typeof raw === 'object') {
      return raw;
    }
    const jsonStr = String(raw);
    const repaired = jsonStr.replace(
      /\\(?!["\\/bfnrtu]|u[0-9a-fA-F]{4})/g,
      '\\\\'
    );
    return JSON.parse(repaired);
  }

  getLastFile() {
    this.circularProgressiveWait = true;
    this.lastFile = [];
    this.lastFileInfo = new FileInfo();
    this.keepAliveFilesService.getLastFile().subscribe(
      (response: any) => {
        if (response != undefined) {
          this.lastFileInfo['data'] = this.datePipe.transform(
            new Date(response.date * 1).toUTCString(),
            'dd-MM-yyyy HH:mm:ss'
          )!;
          this.lastFileInfo['id'] = response.id;
          this.lastFileInfo['crc'] = response.crc;
          // #region agent log
          const loraRaw = response.loraActionsItems;
          const loraType = typeof loraRaw;
          const loraLen = loraType === 'string' ? loraRaw.length : 0;
          const errPos = 27651;
          const ctxStart = Math.max(0, errPos - 30);
          const ctxEnd = Math.min(loraLen, errPos + 30);
          fetch('http://127.0.0.1:7794/ingest/31386176-a271-4604-8e0b-56f6d72451a4',{method:'POST',headers:{'Content-Type':'application/json','X-Debug-Session-Id':'3be493'},body:JSON.stringify({sessionId:'3be493',location:'keep-alive-files.component.ts:getLastFile:pre-parse',message:'loraActionsItems before JSON.parse',data:{loraType,loraLen,ctxStart,ctxEnd,contextSnippet:loraType==='string'?loraRaw.substring(ctxStart,ctxEnd):null,charAtErrPos:loraType==='string'&&loraLen>errPos?loraRaw.charAt(errPos):null,prevChars:loraType==='string'&&loraLen>errPos?loraRaw.substring(errPos-5,errPos+5):null,headSnippet:loraType==='string'?loraRaw.substring(0,120):null,isAlreadyObject:loraType==='object'},timestamp:Date.now(),hypothesisId:'A-B-D-E'})}).catch(()=>{});
          // #endregion
          let a: any;
          try {
            a = this.parseLoraActionsItems(loraRaw);
          } catch (parseErr: any) {
            // #region agent log
            fetch('http://127.0.0.1:7794/ingest/31386176-a271-4604-8e0b-56f6d72451a4',{method:'POST',headers:{'Content-Type':'application/json','X-Debug-Session-Id':'3be493'},body:JSON.stringify({sessionId:'3be493',location:'keep-alive-files.component.ts:getLastFile:parse-error',message:'JSON.parse failed on loraActionsItems',data:{errorMessage:parseErr?.message,loraLen,errPosSnippet:loraType==='string'?loraRaw.substring(errPos-20,errPos+20):null,backslashCount:loraType==='string'?(loraRaw.match(/\\/g)||[]).length:0},timestamp:Date.now(),hypothesisId:'A-C'})}).catch(()=>{});
            // #endregion
            throw parseErr;
          }
          // #region agent log
          fetch('http://127.0.0.1:7794/ingest/31386176-a271-4604-8e0b-56f6d72451a4',{method:'POST',headers:{'Content-Type':'application/json','X-Debug-Session-Id':'3be493'},body:JSON.stringify({sessionId:'3be493',location:'keep-alive-files.component.ts:getLastFile:post-parse',message:'JSON.parse succeeded',data:{itemCount:a?.loraActionsFileItem?.length??null},timestamp:Date.now(),hypothesisId:'B'})}).catch(()=>{});
          // #endregion
          let index = 0;
          response.actionParamList = response.actionParamList.split(',');
          let loraIdSerial = response.loraIdSerial.split(';');
          a.loraActionsFileItem.forEach((item: any) => {
            let loraIdSerialIndex = loraIdSerial.findIndex(
              (loraIdSerialItem: string) => {
                return loraIdSerialItem.startsWith(String(item.loraID) + ',');
              }
            );
            if (loraIdSerialIndex > -1) {
              item.serial = loraIdSerial[loraIdSerialIndex].split(',')[1];
            } else {
              item.serial = '-';
            }
            item.actionParam = String(response.actionParamList[index]).replace(
              '\\',
              ''
            );
            item.expirationDateTime = this.datePipe.transform(
              new Date(item.expirationDateTime * 1000).toUTCString(),
              'dd-MM-yyyy HH:mm:ss'
            )!;
            this.lastFile.push(item);
            index++;
          });
        }
        this.circularProgressiveWait = false;
      },
      (error: HttpErrorResponse) => {
        this.toastService.show(
          'Erro ao carregar último arquivo- ' + error.message,
          {
            classname: 'bg-danger text-center text-white',
            delay: 10000,
          }
        );
        this.circularProgressiveWait = false;
      }
    );
  }

  getDevicesCanDownload() {
    this.devicesCanDownload = [];
    this.circularProgressiveWait = true;
    this.filesIdsCount = { fileId: [], count: [] };
    this.keepAliveFilesService
      .getDevicesCanDownload()
      .subscribe((response: string[]) => {
        response.forEach((item: string) => {
          let itemJson = JSON.parse(item);
          let timerAux = '';
          let dateAux = '';
          if (itemJson.timer != '') {
            timerAux = this.datePipe.transform(
              new Date().setTime(
                new Date().getTime() + Number(itemJson.timer) * 1000
              ),
              'dd-MM-yyyy HH:mm:ss'
            )!;
          }
          if (itemJson.date != '') {
            dateAux = this.datePipe.transform(
              new Date().setTime(Number(itemJson.date) * 1000),
              'dd-MM-yyyy HH:mm:ss'
            )!;
          }
          var fileId = "-";
          if(itemJson.fileId != undefined){
            fileId = itemJson.fileId ;
          }
          var index = this.filesIdsCount.fileId.indexOf(fileId);
          if (index > -1) {
            this.filesIdsCount.count[index] =
              this.filesIdsCount.count[index] + 1;
          } else {
            this.filesIdsCount.fileId.push(fileId);
            this.filesIdsCount.count.push(1);
          }

          this.devicesCanDownload.push({
            serial: itemJson.serial,
            lastFile:
              itemJson.fileId != undefined ? Number(itemJson.fileId) : -1,
            timer: timerAux,
            date: dateAux,
            dateEpoch:
              itemJson.fileId != undefined ? Number(itemJson.date) : -1,
          });
        });
        this.devicesCanDownload = this.devicesCanDownload.sort(
          (a: any, b: any) => Number(b.dateEpoch) - Number(a.dateEpoch)
        );
        this.circularProgressiveWait = false;
      });
  }

  addDeviceCanDownload() {
    this.circularProgressiveWait = true;

    let devicesLst: string[] = this.newSerialCanDownload.split(';');
    let lstUnique = devicesLst.filter((v, i, a) => a.indexOf(v) === i);
    this.keepAliveFilesService
      .addDevicesCanDownload(lstUnique.join(';'))
      .subscribe(
        (response: any) => {
          this.toastService.show('Seriais adicionados com sucesso ', {
            classname: 'bg-success text-center text-white',
            delay: 2500,
          });
          this.circularProgressiveWait = false;
          this.getDevicesCanDownload();
        },
        (error: HttpErrorResponse) => {
          this.toastService.show(
            'Erro ao adicionar seriais para ser possível fazer o download- ' +
              error.message,
            {
              classname: 'bg-danger text-center text-white',
              delay: 10000,
            }
          );
          this.circularProgressiveWait = false;
          this.getDevicesCanDownload();
        }
      );
  }
  zeroTimerDeviceCandDownload(serial: string) {
    this.keepAliveFilesService.zeroTimerDevicesCanDownload(serial).subscribe(
      (response: any) => {
        this.toastService.show('Serial zerado com sucesso ', {
          classname: 'bg-success text-center text-white',
          delay: 2500,
        });
        this.circularProgressiveWait = false;
        this.getDevicesCanDownload();
      },
      (error: HttpErrorResponse) => {
        this.toastService.show(
          'Erro ao zerar timer serial para ser possível fazer o download- ' +
            error.message,
          {
            classname: 'bg-danger text-center text-white',
            delay: 10000,
          }
        );
        this.circularProgressiveWait = false;
        this.getDevicesCanDownload();
      }
    );
  }

  removeDeviceCandDownload(serial: string) {
    this.keepAliveFilesService.removeDevicesCanDownload(serial).subscribe(
      (response: any) => {
        this.toastService.show('Serial removido com sucesso ', {
          classname: 'bg-success text-center text-white',
          delay: 2500,
        });
        this.circularProgressiveWait = false;
        this.getDevicesCanDownload();
      },
      (error: HttpErrorResponse) => {
        this.toastService.show(
          'Erro ao remover serial para ser possível fazer o download- ' +
            error.message,
          {
            classname: 'bg-danger text-center text-white',
            delay: 10000,
          }
        );
        this.circularProgressiveWait = false;
        this.getDevicesCanDownload();
      }
    );
  }
}

export class DeviceCanDownload {
  serial!: string;
  lastFile!: number;
  timer!: string;
  date!: string;
  dateEpoch!: number;
  constructor() {}
}
